import { Routes } from '@angular/router';
import { authPagesGuard } from '@core/guards/auth/auth-pages.guard';
import { AUTH_SLUGS } from '@features/auth/auth.routes';
import { TwxSetPasswordMode } from './twx-set-password.component';

const BRAND = 'Twinny X';

/** /auth/start: the sign-up. */
export const TWX_START_SLUG = 'start';

const setPassword = (path: string, title: string, mode: TwxSetPasswordMode) => ({
    path: `${path}/:token`,
    title: `${title} · ${BRAND}`,
    data: { mode },
    loadComponent: () =>
        import('./twx-set-password.component').then(m => m.TwxSetPasswordComponent),
});

/**
 * TwinnyX's own auth pages, mounted under /auth before Twinny's (routes/app.routes.ts), so
 * they win on the same paths. The login is a one-time code (KAN-266: email → code → in), so
 * there is no password to forget; the set-password pages stay for the invitation and
 * reset links twinny-api still sends. The sign-up is /auth/start (twx-onboarding);
 * invitation and Twinny's old onboarding are still Twinny's.
 */
export const TWX_AUTH_ROUTES: Routes = [
    {
        path: AUTH_SLUGS.login,
        title: `Entrar · ${BRAND}`,
        canActivate: [authPagesGuard],
        loadComponent: () => import('./twx-login.component').then(m => m.TwxLoginComponent),
    },
    setPassword(AUTH_SLUGS.resetPassword, 'Nueva contraseña', 'reset'),
    setPassword(AUTH_SLUGS.choosePassword, 'Bienvenida', 'welcome'),
    {
        // The self-serve sign-up, reached from twinnyx.com's "Start free" with ?url=
        path: TWX_START_SLUG,
        title: `Empieza gratis · ${BRAND}`,
        loadComponent: () =>
            import('@twinnyx/features/onboarding/twx-onboarding.component').then(
                m => m.TwxOnboardingComponent
            ),
    },
    {
        // The code screen of the login (the email waits in TwxAuthOtpService)
        path: AUTH_SLUGS.verify,
        title: `Tu código · ${BRAND}`,
        canActivate: [authPagesGuard],
        loadComponent: () => import('./twx-verify.component').then(m => m.TwxVerifyComponent),
    },
];
